import { MATERIAL_PRESETS, presetChipName } from "./materialPresets";
import { SHEET_PRESETS } from "./sheetPresets";

export const COMBINED_PRESETS = [
  {
    id: "mdf-18-full",
    materialPresetId: "mdf-18",
    sheetPresetId: "full",
    i18nKey: "mdf18Full",
  },
  {
    id: "mdf-18-half",
    materialPresetId: "mdf-18",
    sheetPresetId: "half",
    i18nKey: "mdf18Half",
  },
  {
    id: "spaan-18-half",
    materialPresetId: "spaan-18",
    sheetPresetId: "half",
    i18nKey: "spaan18Half",
  },
  {
    id: "meubelpaneel-18-full",
    materialPresetId: "meubelpaneel-18",
    sheetPresetId: "full",
    i18nKey: "meubelpaneel18Full",
  },
];

function findMaterialPreset(id) {
  return MATERIAL_PRESETS.find((preset) => preset.id === id);
}

function findSheetPreset(id) {
  return SHEET_PRESETS.find((preset) => preset.id === id);
}

export function getCombinedPresets() {
  return COMBINED_PRESETS;
}

export function getCombinedMaterialPresetIds() {
  return [...new Set(COMBINED_PRESETS.map((preset) => preset.materialPresetId))];
}

export function resolveCombinedPreset(combined, display) {
  const material = findMaterialPreset(combined.materialPresetId);
  const sheet = findSheetPreset(combined.sheetPresetId);
  const base = `web.presets.combined.${combined.i18nKey}`;
  const baseLabel = display.t(`${base}.label`);

  return {
    ...combined,
    materialPreset: material,
    sheetPreset: sheet,
    label: `${presetChipName(baseLabel)} ${display.formatThickness(material.defaultThickness)}`.trim(),
    hint: display.formatSheet(sheet.length, sheet.width),
    materialName: display.t(`web.presets.material.${material.i18nKey}.materialName`),
  };
}

export function isActiveCombinedPreset(project, preset) {
  const material = findMaterialPreset(preset.materialPresetId);
  const sheet = findSheetPreset(preset.sheetPresetId);

  return project.materialName === preset.materialName
    && Number(project.sourcePanel.defaultThickness) === material.defaultThickness
    && Number(project.sourcePanel.length) === sheet.length
    && Number(project.sourcePanel.width) === sheet.width;
}
